import RtReconciliationSearchMatchedRequestBase from './base/RtReconciliationSearchMatchedRequestBase';

/**
 * @class RtReconciliationSearchMatchedRequest
 * @extends RtReconciliationSearchMatchedRequestBase
 */
class RtReconciliationSearchMatchedRequest extends RtReconciliationSearchMatchedRequestBase {

}

export default RtReconciliationSearchMatchedRequest;
